var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.237 .12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.101 0a3.451 3.451 0 0 1 3.452 3.451v10.84a3.451 3.451 0 0 1-3.452 3.452H11.775l-5.738 5.695v-5.695H3.45A3.451 3.451 0 0 1 0 14.292V3.452A3.451 3.451 0 0 1 3.451 0zm-.725 9.518H5.312a1.247 1.247 0 0 0 0 2.494h16.064a1.247 1.247 0 0 0 0-2.494m0-4.488H5.312a1.247 1.247 0 0 0 0 2.494h16.064a1.247 1.247 0 1 0 0-2.494",
    opacity: 0.299
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.619 4.642h18.65a3.451 3.451 0 0 1 3.451 3.451v10.84a3.451 3.451 0 0 1-3.451 3.452h-.688v5.695l-5.738-5.695H14.619a3.451 3.451 0 0 1-3.452-3.451V8.093a3.451 3.451 0 0 1 3.452-3.451"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2.493,
    x: 16.023,
    y: 9.173,
    fill: "#FFF",
    opacity: 0.48,
    rx: 1.247
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2.493,
    x: 16.023,
    y: 14.661,
    fill: "#FFF",
    opacity: 0.48,
    rx: 1.247
  }))));
};
export default SvgChat;